module.exports = __webpack_public_path__ + "static/media/card-MasterCard-mobile-inactive.418cfa11.svg";